<div
  class="blotter_table_target"
  #tableTarget
  (drop)="onFileDropped($event)"
  (dragover)="onFileDragged($event)"
  (dragleave)="onFileDragLeave($event)"
  [ngClass]="{'bfx-field-active-bold': canDropFile }"
>
  <ag-grid-angular
    style="width: 100%; height: calc(100% - 46px)"
    class="ag-bcdfx scratchpad pinned-border"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [frameworkComponents]="frameworkComponents"
    [toolPanelSuppressSideButtons]="true"
    enableColResize
    enableSorting
    rowHeight="24"
    multiSortKey="ctrl"
  >
  </ag-grid-angular>

  <div class="bfx-scratchpad-action-bar">
    <input
      #fileInput
      type="file"
      (change)="handleImport($event)"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv"
      (click)="fileInput.value = null"
      style="display: none"
    />
    <button
      class="bfx-button-primary"
      #importButton
      pButton
      type="button"
      [tabindex]="0"
      label="Import"
      [disabled]="importBusy"
      (click)="fileInput.click()"
    ></button>
    <button
      class="bfx-button-secondary"
      #saveButton
      pButton
      type="button"
      [tabindex]="1"
      label="Save"
      [disabled]="!canSave"
      (click)="handleSave()"
    ></button>
    <button
      class="bfx-button-secondary"
      #editButton1
      pButton
      type="button"
      [tabindex]="2"
      label="Edit"
      [disabled]="!canEdit"
      (click)="handleEdit()"
    ></button>
    <button
      class="bfx-button-secondary"
      #copyButton1
      pButton
      type="button"
      [tabindex]="3"
      label="Copy"
      [disabled]="!canCopy"
      (click)="handleCopy()"
    ></button>
    <button
      class="bfx-button-secondary"
      #deleteButton1
      pButton
      type="button"
      [tabindex]="4"
      label="Delete"
      [disabled]="!canDelete"
      (click)="handleDelete()"
    ></button>
    <button
      class="bfx-button-secondary"
      #bulkButton
      pButton
      type="button"
      [tabindex]="5"
      label="Bulk"
      [disabled]="!canBulk"
      (click)="handleBulk()"
    ></button>
    <button
      class="bfx-button-secondary"
      #unbulkButton
      pButton
      type="button"
      [tabindex]="6"
      label="Unbulk"
      [disabled]="!canUnbulk"
      (click)="handleUnbulk()"
    ></button>
    <button
      class="bfx-button-primary"
      #approveButton
      pButton
      type="button"
      [tabindex]="7"
      label="Abort"
      *ngIf="canAbort"
      (click)="handleAbort()"
    ></button>
    <button
      class="bfx-button-negative"
      #rejectButton
      pButton
      type="button"
      [tabindex]="8"
      label="Reject"
      *ngIf="canReject"
      (click)="handleReject()"
    ></button>
    <button
      class="bfx-button-positive"
      #acceptButton
      pButton
      type="button"
      [tabindex]="9"
      label="Accept"
      *ngIf="canAccept"
      (click)="handleAccept()"
    ></button>
    <button
      class="bfx-button-positive"
      #approveButton
      pButton
      type="button"
      [tabindex]="10"
      label="Approve"
      *ngIf="canApprove"
      (click)="handleAccept()"
    ></button>
    <button
      class="bfx-button-positive scratchpad-submit"
      #submitButton
      pButton
      type="button"
      [disabled]="!canSubmit"
      [tabindex]="11"
      label="Submit"
      (click)="handleSubmit()"
    ></button>
  </div>
  <div class="bfx-context-menu-container" bfxElementOnBody>
    <div
      #cm
      [hidden]="!showMenu"
      class="bfx-context-menu"
      style="min-width: 120px"
      [style.left.px]="menuPosition.x"
      [style.top.px]="menuPosition.y"
    >
      <ul>
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canSubmit, 'bfx-context-menu-item-disabled': !canSubmit}"
          (click)="canSubmit && handleSubmit()"
        >
          <span>Submit</span>
        </li>
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canAccept, 'bfx-context-menu-item-disabled': !canAccept}"
          (click)="canAccept && handleAccept()"
        >
          <span>Accept</span>
        </li>
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canApprove, 'bfx-context-menu-item-disabled': !canApprove}"
          (click)="canApprove && handleAccept()"
        >
          <span>Approve</span>
        </li>
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canAbort, 'bfx-context-menu-item-disabled': !canAbort}"
          (click)="canAbort && handleAbort()"
        >
          <span>Abort</span>
        </li>
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canReject, 'bfx-context-menu-item-disabled': !canReject}"
          (click)="canReject && handleReject()"
        >
          <span>Reject</span>
        </li>
        <hr class="bfx-context-menu-hr" />
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canBulk, 'bfx-context-menu-item-disabled': !canBulk}"
          (click)="canBulk && handleBulk()"
        >
          <span>Bulk</span>
        </li>
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canEdit, 'bfx-context-menu-item-disabled': !canUnbulk}"
          (click)="canUnbulk && handleUnbulk()"
        >
          <span>Unbulk</span>
        </li>
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canEdit, 'bfx-context-menu-item-disabled': !canEdit}"
          (click)="canEdit && handleEdit()"
        >
          <span>Edit</span>
        </li>
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canCopy, 'bfx-context-menu-item-disabled': !canCopy}"
          (click)="canCopy && handleCopy()"
        >
          <span>Copy</span>
        </li>
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canDelete, 'bfx-context-menu-item-disabled': !canDelete}"
          (click)="canDelete && handleDelete()"
        >
          <span>Delete</span>
        </li>
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canSave, 'bfx-context-menu-item-disabled': !canSave}"
          (click)="canSave && handleSave()"
        >
          <span>Save</span>
        </li>
        <li
          [ngClass]="{'bfx-context-menu-item-enabled': canView, 'bfx-context-menu-item-disabled': !canView}"
          (click)="canView && handleView()"
        >
          <span>View</span>
        </li>
      </ul>
    </div>
  </div>
</div>
